// todo crutch: BMO for some reason provides datetimes without time zones,
//  but after some research we figured out that they are in fact provided in UTC
//  https://dev.azure.com/etnasoft/ETNA_TRADER/_workitems/edit/213885
import moment from 'moment-timezone';

export const acceptUTC = (date: string, format?: string) => {
    const utcDate = moment.utc(date).format();
    return moment(utcDate).format(format);
};
